<template>
    <v-container class="webbox-color-styling">
        <label class="v-label d-block">{{title}}</label>
            <v-icon x-large :color="ccolor">$colorPreview</v-icon><action-button 
                :tooltip="$t('webboxes.styling.color.edit')" 
                icon="$edit"
                @click="$emit('pick', { prop: property, key: css })"  
                 />
            <action-button class="pfcl1618818360" 
                :tooltip="$t('webboxes.styling.color.remove')" 
                icon="$clear"
                @click="clearColor()" 
                 />
    </v-container>
</template>
<script>
export default {
    name: 'ColorStyling',
    props: { 'color': String, 'background-color': String, property: String, css: String, title: String },
    data() {
        return {
        }
    },
    watch: {
    },
    computed: {
        ccolor() {
            return this.css == 'background-color' ? this.backgroundColor : this.color;
        }
    },
    methods: {
        clearColor() {
            this.$emit(`update:${this.css}`, null);
            this.$emit('clear');
        }
    }
}
</script>